'use strict';
import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppointmentTime from '../../dto/AppointmentTime';
import AppointmentListItem from './AppointmentListItem';
import Alert from '../Alert';
import { FormattedMessage } from 'react-intl';
import { sortByTimeOldestFirst } from '../../utils/SortUtils';
import ToolTip from '../Tooltip';
import { APPOINTMENTS } from '../../data/reducer';
import Loader from '../Loader';
import { selectShowAppointmentPagePlaceholder } from '../../data/appointment/selector';

const { id: module_id } = module;

class ReservedAppointments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlreadyRescheduledTooltip: null,
    };
  }

  change = (appointmentId) => {
    this.props.history.push(`/appointments/reschedule/${appointmentId}`);
  };

  //check whether user is allowed to reschedule given appointment
  appointmentCanBeRescheduled = (appointment) => {
    return (
      appointment.modify === 'CAN_RESCHEDULE_ONCE' ||
      appointment.modify === 'CAN_RESCHEDULE_MULTIPLE'
    );
  };

  appointmentAlreadyRescheduled = (appointment) => {
    return appointment.modify === 'ALREADY_RESCHEDULED';
  };

  showAppointmentAlreadyRescheduledTooltip = (appointmentId, show) => {
    this.setState({
      ...this.state,
      showAlreadyRescheduledTooltip: show ? appointmentId : null,
    });
  };

  toggleAppointmentAlreadyRescheduledTooltip = (appointmentId) => {
    let current = this.state.showAlreadyRescheduledTooltip;
    this.setState({
      ...this.state,
      showAlreadyRescheduledTooltip: current !== null ? null : appointmentId,
    });
  };

  render() {
    let { data, isFetching, error, showPlaceholder } = this.props,
      info = null,
      appointmentItems = null;

    if (error) {
      info = <Alert message={`${module_id}.${error.code}`} />;
    }

    if (showPlaceholder || isFetching) {
      return null;
    }

    if (!error && !isFetching && isEmpty(data)) {
      return null;
    }

    if (!error) {
      appointmentItems = data
        .map(AppointmentTime.of)
        .sort(sortByTimeOldestFirst('dateStart'))
        .map((appointment) => {
          let appointmentId = appointment.id;
          return (
            <AppointmentListItem
              key={appointmentId}
              type={'DISPLAY'}
              data={appointment}
              showAsSelected={true}
            >
              {this.appointmentAlreadyRescheduled(appointment) ? (
                <div className="already-rescheduled">
                  <span className="text">
                    <FormattedMessage id="already.changed" />
                  </span>
                  <button
                    data-mytip={`already-rescheduled-${appointmentId}`}
                    style={{
                      padding: '2px',
                      background: 'none',
                      border: 'none',
                    }}
                    className="already-rescheduled-icon fa icon-info-sign"
                    onMouseDown={(event) => {
                      event.preventDefault();
                    }}
                    onClick={() => {
                      this.toggleAppointmentAlreadyRescheduledTooltip(
                        appointmentId
                      );
                    }}
                    onFocus={() => {
                      this.showAppointmentAlreadyRescheduledTooltip(
                        appointmentId,
                        true
                      );
                    }}
                    onBlur={() =>
                      this.showAppointmentAlreadyRescheduledTooltip(
                        appointmentId,
                        false
                      )
                    }
                  />
                  <ToolTip
                    show={
                      this.state.showAlreadyRescheduledTooltip === appointmentId
                    }
                    id={`already-rescheduled-${appointmentId}`}
                  >
                    <p>
                      <FormattedMessage
                        id={`${module_id}.reschedule.allowed.once`}
                      />
                    </p>
                  </ToolTip>
                </div>
              ) : (
                <button
                  disabled={!this.appointmentCanBeRescheduled(appointment)}
                  style={{ marginLeft: '10px', float: 'right' }}
                  className="appointment__button"
                  onClick={() => {
                    this.change(appointmentId);
                  }}
                >
                  <span className={'show-mobile'}>
                    <FormattedMessage id="move.time" />
                  </span>
                  <span className={'show-desktop'}>
                    <FormattedMessage id="move" />
                  </span>
                </button>
              )}
            </AppointmentListItem>
          );
        });
    }

    return (
      <div>
        <h2 className={'subheading-gray'}>
          <FormattedMessage id={`${module_id}.changed.times`} />
        </h2>
        <ul className="appointment-container">{info || appointmentItems}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { isFetching, data, error } = state[APPOINTMENTS].appointments;
  return {
    isFetching,
    data,
    error,
    showPlaceholder: selectShowAppointmentPagePlaceholder(state),
  };
};

export default connect(mapStateToProps)(withRouter(ReservedAppointments));
